<div class="modal-container">
  <div class="modal-header">
    <h3 class="mat-h3">{{ title }}</h3>
  </div>

  <div class="modal-content">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-field-container">
        <label for="group-name" class="form-field-label">Name *</label>
        <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
          <input id="group-name" matInput formControlName="name" placeholder="Enter group name" />
          @if (form.get('name')?.hasError('required')) {
            <mat-error>Name is required</mat-error>
          }
          @if (form.get('name')?.hasError('maxlength')) {
            <mat-error>Name cannot exceed 100 characters</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field-container">
        <label for="group-instruction" class="form-field-label">Instruction <mat-icon class="info-icon" matTooltip="Instructions for how the AI should use this context group">info</mat-icon></label>
        <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
          <textarea id="group-instruction" matInput formControlName="instruction" placeholder="Enter instructions for AI usage" rows="4"></textarea>
          <mat-hint align="end">{{ form.get('instruction')?.value?.length || 0 }}/2000</mat-hint>
          @if (form.get('instruction')?.hasError('maxlength')) {
            <mat-error>Instruction cannot exceed 2000 characters</mat-error>
          }
        </mat-form-field>
      </div>

      <div class="form-field-container">
        <label for="group-description-tools" class="form-field-label">Description for Tools<mat-icon class="info-icon" matTooltip="Short description used when this group is exposed as a tool">info</mat-icon></label>
        <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
          <textarea id="group-description-tools" matInput formControlName="descriptionForTools" placeholder="Brief description for tool usage" rows="2"></textarea>
          <mat-hint align="end">{{ form.get('descriptionForTools')?.value?.length || 0 }}/500</mat-hint>
          @if (form.get('descriptionForTools')?.hasError('maxlength')) {
            <mat-error>Description cannot exceed 500 characters</mat-error>
          }
        </mat-form-field>
      </div>

      <!-- Countries -->
      <div class="form-field-container">
        <label class="form-field-label">Countries<mat-icon class="info-icon" matTooltip="Filter this context group by countries">info</mat-icon></label>
        <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
          <mat-select formControlName="countries" multiple placeholder="Select countries (optional)">
            @for (country of availableCountries; track country._id) {
              <mat-option [value]="country._id">{{ country.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-row">
        <div class="form-field-container half-width">
          <label for="group-priority" class="form-field-label">Priority<mat-icon class="info-icon" matTooltip="Priority level (1=highest, 5=lowest). Propagates to all items in this group.">info</mat-icon></label>
          <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
            <mat-select id="group-priority" formControlName="priority" placeholder="Select priority (optional)">
              <mat-option [value]="null">-- None --</mat-option>
              @for (option of priorityOptions; track option.value) {
                <mat-option [value]="option.value">{{ option.label }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="form-field-container half-width">
          <label for="group-status" class="form-field-label">Status</label>
          <mat-form-field class="gingr-input-wrapper w-full" appearance="outline">
            <mat-select id="group-status" formControlName="status">
              <mat-option value="active">Active</mat-option>
              <mat-option value="inactive">Inactive</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="form-field-container checkbox-field">
        <mat-checkbox formControlName="approved" color="primary">Approved</mat-checkbox>
        <p class="helper-text">Approved groups and their items are available for bot usage</p>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button mat-stroked-button (click)="onCancel()" [disabled]="loading">Cancel</button>
    <button mat-raised-button color="accent" (click)="onSubmit()" [disabled]="form.invalid || loading">
      @if (loading) { <mat-spinner diameter="20"></mat-spinner> }
      @if (!loading) { <span>{{ isEdit ? 'Update' : 'Create' }}</span> }
    </button>
  </div>
</div>


